import { Box } from "@chakra-ui/react"
import Divider from "./Divider"

const DividerView = ({ layout, blockStyles }) => (
  <Box>
    <Divider layout={layout} blockStyles={blockStyles} />
  </Box>
)

export default DividerView
